import "@fortawesome/fontawesome-free/css/all.min.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/api";
import { useNotification } from "../Notification/notification";
import Header, { Footer } from "./header";
import "./homepage.css";

function Home() {
  const { notify } = useNotification();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);

  const [bestSellList, setBestSellList] = useState([]);
  const [topSelling, setTopSelling] = useState([]);
  const [trending, setTrending] = useState([]);
  const [recentlyAdded, setRecentlyAdded] = useState([]);
  const [topRated, setTopRated] = useState([]);

  const [dealsDayList, setDealsDayList] = useState([]);
  const [adsList, setAdsList] = useState([]);
  const [adsIndex, setAdsIndex] = useState(0);

  const [productList, setProductList] = useState([]);
  const [bannerList, setBannerList] = useState([]);

  const adsRef = useRef(null);

  const slidesPerView = 5;
  const featureSliderGap = 14;

  const sliderCloneCount = Math.min(slidesPerView, productList.length);

  const [currentProductIndex, setCurrentProductIndex] = useState(0);
  const [productSliderTransition, setProductSliderTransition] = useState(true);

  useEffect(() => {
    if (productList.length > 0) {
      setCurrentProductIndex(sliderCloneCount);
    }
  }, [productList.length, sliderCloneCount]);

  const loopedProductList = productList;

  useEffect(() => {
    if (!productList.length) return;

    if (currentProductIndex >= productList.length + sliderCloneCount) {
      setTimeout(() => {
        setProductSliderTransition(false);
        setCurrentProductIndex(sliderCloneCount);
      }, 500);
    }

    if (currentProductIndex < sliderCloneCount) {
      setTimeout(() => {
        setProductSliderTransition(false);
        setCurrentProductIndex(productList.length + sliderCloneCount - 1);
      }, 500);
    }
  }, [currentProductIndex, productList.length, sliderCloneCount]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_URL}/api/product-flags`);
        const data = await res.json();

        setProducts(data.popular?.slice(0, 3) || []);
        setBestSellList(data.bestSell || []);
        setTopSelling(data.topSelling || []);
        setTrending(data.trending || []);
        setRecentlyAdded(data.recentlyAdded || []);
        setTopRated(data.topRated || []);
        setAdsList(data.ads || []);
        setBannerList(data.banner || []);
        setProductList(data.featured || []);

        setDealsDayList(
          (data.dealsOfDay || []).map((deal) => ({
            ...deal,
            endTime: Date.now() + 24 * 60 * 60 * 1000,
          })),
        );
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) =>
        bannerList.length ? (prev + 1) % bannerList.length : 0,
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [bannerList.length]);

  const moveSlide = (direction) => {
    if (!bannerList.length) return;

    setSlideIndex((prev) => {
      const next = prev + direction;
      if (next >= bannerList.length) return 0;
      if (next < 0) return bannerList.length - 1;
      return next;
    });
  };
  const addToCart = (item) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];

    const exists = cart.find((p) => p.id === item.id);

    if (exists) {
      notify(`${item.name} is already in cart`, "info");
      return;
    }

    const formattedItem = {
      id: item.id,
      name: item.name,
      price: item.price,
      image: item.image,
      quantity: 1,
    };

    cart.push(formattedItem);
    localStorage.setItem("cart", JSON.stringify(cart));

    notify(`${item.name} added to cart!`, "success");
  };
  const moveProductSlide = (direction) => {
    if (!productList.length) return;

    setCurrentProductIndex((prev) => {
      const next = prev + direction;

      const maxIndex = productList.length - slidesPerView;

      if (next < 0) return 0;
      if (next > maxIndex) return maxIndex;

      return next;
    });
  };
  const carouselRef = useRef(null);
  const getCountdown = (endTime) => {
    const now = Date.now();
    const diff = endTime - now;

    return {
      days: Math.floor(diff / 86400000),
      hours: Math.floor((diff % 86400000) / 3600000),
      minutes: Math.floor((diff % 3600000) / 60000),
      seconds: Math.floor((diff % 60000) / 1000),
    };
  };

  return (
    <>
      <Header />
      <div className="Banner-container">
        <div className="slideshow-container">
          <div
            className="slides"
            style={{ transform: `translateX(${-slideIndex * 100}%)` }}
          >
            {bannerList.map((banner, i) => {
              const discountedPrice =
                banner.price - (banner.price * (banner.discount || 0)) / 100;
              return (
                <div className="slide" key={i}>
                  <img src={banner.image} alt={banner.name} />
                  <div className="banner-info">
                    <h3>{banner.name}</h3>
                    <p>
                      <span className="cut-price">
                        Rs.{banner.price.toFixed(2)}
                      </span>
                      <span className="discounted-price">
                        Rs.{discountedPrice.toFixed(2)}
                      </span>
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          <button className="prev" onClick={() => moveSlide(-1)}>
            &#10094;
          </button>
          <button className="next" onClick={() => moveSlide(1)}>
            &#10095;
          </button>

          <div className="banner-dots">
            {bannerList.map((banner, index) => (
              <button
                key={banner.id || index}
                className={`banner-dot ${index === slideIndex ? "active" : ""}`}
                onClick={() => setSlideIndex(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="product-container featured-section">
        <h1 className="featured-categories">Featured Categories</h1>
        <div className="slider-wrapper featured-slider-shell">
          <button className="prev-btn" onClick={() => moveProductSlide(-1)}>
            &#10094;
          </button>
          <div className="product-box-container">
            <ul className="product-slider" id="productSlider" style={{}}>
              {loopedProductList.map((p, idx) => (
                <li className="product-item" key={`${p.id}-${idx}`}>
                  <div className="product-info">
                    <h2 className="product-name featured-product-name">
                      {p.name}
                    </h2>
                    <img src={p.image} alt={p.name} className="product-image" />
                    <p className="product-price featured-product-price">
                      Rs. {p.price}
                    </p>
                    {/* <button className="add-to-cart-btn" onClick={() => addToCart(p)}>Add to Cart</button> */}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <button className="next-btn" onClick={() => moveProductSlide(1)}>
            &#10095;
          </button>
        </div>
      </div>

      <div className="ads-product-container">
        {products.map((product) => (
          <div className="product-box-ads" key={product.id}>
            <img src={product.image} alt={product.name} />
            <h3>{product.name}</h3>
            <p>Rs. {product.price}</p>
            <button className="shop-now-btn" onClick={() => addToCart(product)}>
              Shop Now
            </button>
          </div>
        ))}
      </div>

      <h2 className="popular-product-heading">Popular Products</h2>
      <div className="column">
        {productList.map((product) => (
          <div
            className="product-card"
            key={product.id}
            onClick={() => navigate(`/product/${product.slug}/${product.id}`)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={product.image}
              alt={product.name}
              className="product-image"
            />
            <h3 className="product-name">{product.name}</h3>
            <p className="product-price">Rs. {product.price}</p>

            <div className="product-actions">
              {/* Add to Cart */}

              <button
                className="cart-btn"
                onClick={(e) => {
                  e.stopPropagation();

                  const cart = JSON.parse(localStorage.getItem("cart")) || [];

                  if (!cart.find((p) => p.id === product.id)) {
                    cart.push(product);
                    localStorage.setItem("cart", JSON.stringify(cart));
                    notify(`${product.name} added to cart!`, "success");
                  } else {
                    notify(`${product.name} is already in the cart.`, "info");
                  }
                }}
                title="Add to Cart"
              >
                <i className="fa-solid fa-cart-shopping"></i>
              </button>

              {/* View Product */}

              <button
                className="view-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  notify(`Viewing ${product.name}`);
                }}
                title="View Product"
              >
                <i className="fa-solid fa-eye"></i>
              </button>
              {/* Add to Wishlist */}
              <button
                className="wishlist-btn"
                onClick={(e) => {
                  e.stopPropagation();

                  let wishlist =
                    JSON.parse(localStorage.getItem("wishlist")) || [];

                  const exists = wishlist.find((p) => p.id === product.id);

                  if (!exists) {
                    wishlist.push(product);
                    localStorage.setItem("wishlist", JSON.stringify(wishlist));
                    notify(`${product.name} added to wishlist!`, "success");
                  } else {
                    notify(`${product.name} is already in wishlist.`, "info");
                  }
                }}
                title="Add to Wishlist"
              >
                <i className="fa-solid fa-heart"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      <h2 className="heading-daily">Daily Best Sells</h2>
      <div className="best-sell">
        {/* Featured Product */}

        <div className="fixed-container">
          {topSelling.slice(0, 1).map((item) => (
            <div key={item.id}>
              <img src={item.image} alt={item.name} />

              <h3>{item.name}</h3>

              <p className="description">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="carousel-container">
          {/* Left Arrow */}
          <button
            className="arrow-btn"
            onClick={() =>
              carouselRef.current.scrollBy({ left: -220, behavior: "smooth" })
            }
          >
            &#10094;
          </button>

          {/* Right Arrow */}
          <button
            className="arrow-btn"
            onClick={() =>
              carouselRef.current.scrollBy({ left: 220, behavior: "smooth" })
            }
          >
            &#10095;
          </button>

          {/* Carousel Items */}
          <div className="carousel" ref={carouselRef}>
            {productList.slice(1).map((product) => (
              <div
                className="carousel-item"
                key={product.id}
                onClick={() =>
                  navigate(`/product/${product.slug}/${product.id}`)
                }
                style={{ cursor: "pointer" }}
              >
                <img src={product.image} alt={product.name} />
                <h3>{product.name}</h3>
                <p>Rs. {product.price}</p>

                <div className="product-icons">
                  <button
                    className="wishlist-btn"
                    title="Add to Wishlist"
                    onClick={(e) => {
                      e.stopPropagation(); // ✅ IMPORTANT

                      const wishlist =
                        JSON.parse(localStorage.getItem("wishlist")) || [];

                      if (!wishlist.find((p) => p.id === product.id)) {
                        wishlist.push(product);
                        localStorage.setItem(
                          "wishlist",
                          JSON.stringify(wishlist),
                        );
                        notify(`${product.name} added to wishlist!`, "success");
                      } else {
                        notify(
                          `${product.name} is already in wishlist.`,
                          "info",
                        );
                      }
                    }}
                  >
                    <i className="fas fa-heart"></i>
                  </button>

                  <button
                    className="view-btn"
                    onClick={(e) => {
                      e.stopPropagation();

                      notify(`Viewing ${product.name}`, "info");
                    }}
                    title="View Product"
                  >
                    <i className="fa-solid fa-eye"></i>
                  </button>
                </div>
                <button
                  className="text-add-to-cart-btn"
                  onClick={(e) => {
                    e.stopPropagation();

                    addToCart(product);
                  }}
                >
                  Add To Cart
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div>
        <h2 className="deals-of-the-day">Deals Of The Day</h2>
        <div className="deals-container">
          {dealsDayList.slice(0, 3).map((deal) => {
            const countdown = getCountdown(deal.endTime);
            return (
              <div className="deal-box" key={deal.id}>
                <img src={deal.image} alt={deal.name} className="deal-image" />
                <div className="countdown">
                  <div>
                    <span>{countdown.days}</span>
                    <p>Days</p>
                  </div>
                  <div>
                    <span>{countdown.hours}</span>
                    <p>Hours</p>
                  </div>
                  <div>
                    <span>{countdown.minutes}</span>
                    <p>Min</p>
                  </div>
                  <div>
                    <span>{countdown.seconds}</span>
                    <p>Sec</p>
                  </div>
                </div>
                <h3>{deal.name}</h3>
                <p className="deal-price">Rs. {deal.price}</p>
                <button
                  className="deal-cart-btn"
                  onClick={() => addToCart(deal)}
                >
                  Add To Cart
                </button>
              </div>
            );
          })}
        </div>
      </div>

      <div className="selling-product">
        {[
          { title: "Top Selling Products", data: topSelling },
          { title: "Trending Products", data: trending },
          { title: "Recently Added", data: recentlyAdded },
          { title: "Top Rated", data: topRated },
        ].map((cat, idx) => (
          <div className="product-category" key={idx}>
            <h3 className="category-title">{cat.title}</h3>
            <div className="small-product-cards">
              {cat.data.map((product) => (
                <div className="small-product-card" key={product.id}>
                  <img
                    src={product.image}
                    alt={product.name}
                    className="small-product-image"
                  />
                  <h4 className="small-product-name">{product.name}</h4>
                  <p className="small-product-price">Rs. {product.price}</p>
                  <p className="small-product-desc">{product.description}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Banner Below / Ads */}

      <div className="Banner-container-below">
        <div className="slideshow-wrapper">
          <div className="slideshow-container-below">
            <div
              className="ads-slider"
              ref={adsRef}
              style={{ display: "flex", transition: "transform 0.5s ease" }}
            >
              {adsList.map((ad) => (
                <a
                  key={ad.id}
                  href={ad.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ minWidth: "100%" }}
                >
                  <img src={ad.image} alt={ad.name} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tags */}
      <div className="tags">
        {[
          {
            icon: "fas fa-tags",
            color: "#ff5733",
            title: "Best Prices & Offers",
            desc: "Get the lowest prices on top-quality products with exclusive daily offers and discounts.",
          },
          {
            icon: "fas fa-truck",
            color: "#3498db",
            title: "Free Delivery",
            desc: "Enjoy fast and reliable free delivery on eligible orders right to your doorstep.",
          },
          {
            icon: "fas fa-gift",
            color: "#f1c40f",
            title: "Great Daily Deals",
            desc: "Unlock limited-time deals and special discounts updated every single day.",
          },
          {
            icon: "fas fa-th-large",
            color: "#2ecc71",
            title: "Wide Assortment",
            desc: "Explore a huge range of products across multiple categories in one place.",
          },
          {
            icon: "fas fa-undo",
            color: "#9b59b6",
            title: "Easy Returns",
            desc: "Hassle-free returns and quick refunds for a smooth shopping experience.",
          },
        ].map((t, i) => (
          <div className="tag" key={i}>
            <i className={t.icon} style={{ color: t.color }}></i>
            <div className="tag-content">
              <span>{t.title}</span>
              <p>{t.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Your existing footer */}
      <Footer />
    </>
  );
}

export default Home;
